import React from "react";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/AndroidOutlined";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import BottomNav from "./BottomNav";
import AppBar from "./AppBar";
import { FacebookShareButton, WhatsappShareButton } from "react-share";
import { FacebookIcon, WhatsappIcon } from "react-share";

function About() {
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    large: {
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  }));
  const classes = useStyles();
  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar />
      <br />
      <br />
      <br />
      <br />
      <Container>
        <Typography style={{ color: "#3f51b5" }}>About</Typography>
        <br />
        <Grid container>
          <Grid item xs={12}>
            <Grid container justify="center">
              <Avatar
                alt="logo"
                src="./images/logo192.png"
                className={classes.large}
                justify="center"
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Typography>
          Thank you for using Tip and Bill Calculator application. Please help
          us by reviewing the app on the Play Store and sharing the app with
          your friends.
        </Typography>
        <br />
        <Grid container>
          <Grid item xs={12}>
            <Grid container justify="center">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.button}
                startIcon={<CloudUploadIcon />}
                href="https://play.google.com/store/apps/details?id=com.tipandbillcalculator.app"
              >
                Review the app
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Typography>
          Tip and Bill Calculator: v1.0.1. Designed and developed by{" "}
          <Link href="https://lyubovalchev.co.za/">Lyubomir Valchev</Link>
        </Typography>
        <br />
        <Typography>
          <Link href="/termsandconditions">Terms and Conditions</Link> ||{" "}
          <Link href="/privacypolicy">Privacy Policy</Link>
        </Typography>
        <br />
        <Grid container>
          <Grid item xs={12}>
            <Grid container justify="center">
              <FacebookShareButton
                url={
                  "https://play.google.com/store/apps/details?id=com.tipandbillcalculator.app"
                }
                style={{ marginRight: "10px" }}
              >
                <FacebookIcon size={50} round={true} />
              </FacebookShareButton>
              <WhatsappShareButton
                url={
                  "https://play.google.com/store/apps/details?id=com.tipandbillcalculator.app"
                }
              >
                <WhatsappIcon size={50} round={true} />
              </WhatsappShareButton>
            </Grid>
          </Grid>
        </Grid>
        <br /> <br /> <br />
      </Container>
      <BottomNav />
    </React.Fragment>
  );
}

export default About;
